import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import AudioPlayer from '../../../components/AudioPlayer';

const GlossaryTermCard = ({ term, getCategoryColor, getDifficultyColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-surface-lighter border border-border rounded-xl overflow-hidden hover:border-accent-purple/50 transition-all duration-300 group">
      <div 
        className="p-6 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-start justify-between gap-4 mb-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-xl font-bold text-white group-hover:text-accent-purple transition-colors">
                {term?.term}
              </h3>
              {term?.pronunciation && (
                <div onClick={(e) => e?.stopPropagation()}>
                  <AudioPlayer
                    audioUrl={term?.pronunciation}
                    label="Hear"
                    size="sm"
                    variant="ghost"
                    showDuration={false}
                    onPlayStart={() => {}}
                    onPlayEnd={() => {}}
                  />
                </div>
              )}
            </div>
            
            <div className="flex flex-wrap items-center gap-2">
              <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getCategoryColor(term?.category)}`}>
                {term?.category?.replace('_', ' ')?.replace(/\b\w/g, l => l?.toUpperCase())}
              </span>
              {term?.difficulty && (
                <span className={`text-xs font-medium ${getDifficultyColor(term?.difficulty)}`}>
                  {term?.difficulty?.charAt(0)?.toUpperCase() + term?.difficulty?.slice(1)}
                </span>
              )}
              <span className="text-xs text-text-secondary">
                {term?.plays?.title}
              </span>
            </div>
          </div>
          
          <Icon 
            name={isExpanded ? "ChevronUp" : "ChevronDown"} 
            size={24} 
            className="text-text-secondary group-hover:text-accent-purple transition-colors flex-shrink-0" 
          />
        </div>

        <p className="text-text-secondary leading-relaxed">
          {term?.definition}
        </p>
      </div>
      {isExpanded && (
        <div className="px-6 pb-6 space-y-4 border-t border-border/50 pt-4 animate-slide-down">
          {term?.example_usage && (
            <div className="bg-surface-dark rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Quote" size={16} className="text-accent-purple" />
                <span className="text-sm font-semibold text-white">Example Usage</span>
              </div>
              <p className="text-text-secondary italic text-sm leading-relaxed">
                "{term?.example_usage}"
              </p>
            </div>
          )}

          {term?.pronunciation && (
            <div className="bg-surface-dark rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <Icon name="Volume2" size={16} className="text-accent-blue" />
                <span className="text-sm font-semibold text-white">Pronunciation Guide</span>
              </div>
              <AudioPlayer
                audioUrl={term?.pronunciation}
                label="Play Pronunciation"
                size="md"
                variant="outline"
                showDuration={true}
                onPlayStart={() => {}}
                onPlayEnd={() => {}}
              />
            </div>
          )}

          <div className="flex items-center gap-3 text-xs text-text-secondary pt-2">
            <Icon name="BookText" size={14} />
            <span>From {term?.plays?.title}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlossaryTermCard;